import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Usuario} from "../../models/usuario";
import {ValidatorService} from "../../core/services/validator.service";
import {LoginService} from "../../services/login.service";
import {ActivatedRoute, Router} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";
import {MessageService} from "../../core/services/message.service";
import {Login} from "../../models/login";
import {Perfil} from "../../models/perfil";
import {isUndefined} from "util";
import {MatDialog} from "@angular/material";
import {DialogSolicitarAcessoComponent} from "../dialogs/dialog-solicitar-acesso/dialog-solicitar-acesso.component";
import {GovBrService} from "../../services/govbr.service";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    public usuario: Usuario;
    public form: FormGroup;
    public inscricao: Subscription;
    public hidden: boolean = false;

    constructor(
        private loadingService: NgxSpinnerService,
        private messageService: MessageService,
        private loginService: LoginService,
        private govbrservice: GovBrService,
        private route: ActivatedRoute,
        private router: Router,
        private dialog: MatDialog) {

    }

    ngOnInit() {
        let login: Login = this.loginService.getAuth();
        if (login) {
            if (this.route.snapshot.params.perfil) {
                this.logout();
            } else {
                let url: string = "/";
                if (login.perfil == Perfil.GESTOR && login.flg_externo != true && login.flg_externo != null) {
                    url += "planos";
                } else if (login.perfil == Perfil.ADMINISTRADOR && login.flg_externo != true && login.flg_externo != null) {
                    url += "gerencial";
                }
                this.router.navigateByUrl(url);
            }
        }
        let token: string = this.route.snapshot.params.token;
        if (token) {
            this.loadingService.show();
            this.loginService.validate(token).subscribe(() => {
                this.messageService.showSuccess("Usuário ativado com sucesso, realize o login com o usuário e senha informados no cadastro");
                this.router.navigateByUrl("/login");
                this.loadingService.hide();
            }, (error: any) => {
                let message: string = "Ocorreu um erro ao tentar ativar o usuário, favor tente novamente";
                if (!isUndefined(error.error.message)) {
                    message = error.error.message;
                }
                this.messageService.showError(message);
                this.loadingService.hide();
            });
        }
        this.usuario = new Usuario();
        this.form = new FormGroup({
            username: new FormControl(this.usuario.txt_username, [
                Validators.required,
            ]),
            password: new FormControl(this.usuario.txt_senha, [
                Validators.required,
            ])
        });

        this.inscricao = this.route.queryParams.subscribe((queryParams: any) => {
                if(queryParams.code) {
                    this.loadingService.show();
                    this.govbrservice.setCode(queryParams.code);
                    this.govbrservice.authorizeInGovBr().subscribe();
                }
            }
        )}

    ngOnDestroy() {
        this.inscricao.unsubscribe();
    }

    login(): void {
        if (this.form.valid) {
            this.loadingService.show();
            this.loginService.loginUsuario(this.form.get("username").value, this.form.get("password").value).subscribe((response: any) => {
                this.loadingService.hide();
                window.location.href = "/login";
            }, (error) => {
                this.loadingService.hide();
                if (error.status === 500) {
                    this.messageService.showError(error.error);
                }
                else if (error.status === 416) {
                    this.govbrservice.storeLocalItem('ldapUser', error.error);
                    this.router.navigateByUrl("/completar-cadastro-ad");
                }
            });
        }
    }

    logout(): void {
        this.loadingService.show();
        this.loginService.logout();
        this.router.navigateByUrl("/login");
        setTimeout(() => {
            window.location.reload(true);
        }, 100);
    }

    modal(): void {
        this.dialog.open(DialogSolicitarAcessoComponent, {width: '400px'});
    }

    redirectGovBr(): void {
        this.govbrservice.redirectGovBr();
    }
}
